import { pushGaData } from '../common';
import { mapTeliaFooterSocialMediaItems, socialMediaConf, getTeliaFooterFooter, mapTeliaFooterBottomLinks, resolveUrl } from './util/FooterColumnMapper';
export const getBrandSocialMediaItems = (rootStore) => {
    const { brand } = rootStore.environmentStore;
    if (brand === 'telia') {
        return mapTeliaFooterSocialMediaItems(rootStore);
    }
    const translate = rootStore.translationsStore.translate;
    const { facebookUrl, instagramUrl, tikTokUrl } = socialMediaConf[brand];
    if (brand === 'super') {
        return [
            {
                url: facebookUrl,
                label: translate('facebook.label'),
                icon: '#facebook'
            },
            {
                url: instagramUrl,
                label: translate('instagram.label'),
                icon: '#instagram'
            },
            {
                url: tikTokUrl,
                label: translate('tiktok.label'),
                icon: '#logo-tiktok'
            }
        ];
    }
    return [
        {
            url: facebookUrl,
            label: translate('facebook.label'),
            icon: '#facebook'
        }
    ];
};
export const getBrandFooterFooter = (rootStore) => {
    const { brand } = rootStore.environmentStore;
    const { translate } = rootStore.translationsStore;
    if (brand === 'telia') {
        return getTeliaFooterFooter(rootStore.translationsStore.translate);
    }
    if (brand === 'super') {
        return [
            {
                content: translate('footer.super.trademark'),
                className: 'text-weight-normal'
            }
        ];
    }
    return undefined;
};
export const getBrandFooterBottomLinks = (rootStore) => {
    const { brand } = rootStore.environmentStore;
    if (brand === 'telia') {
        return mapTeliaFooterBottomLinks(rootStore);
    }
    return createFooterNavTree(rootStore);
};
export const getBrandLogoProps = (rootStore) => {
    var _a, _b;
    const { app, brand, URLData } = rootStore.environmentStore;
    const { setLocation } = rootStore.locationStore;
    let baseUrl = app === 'public' ? URLData.localizedPath : URLData.publicURL;
    if (brand === 'telia') {
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.includes('ari')) {
            baseUrl = `${baseUrl}/ari`;
        }
        else {
            baseUrl = `${baseUrl}/era`;
        }
    }
    return {
        url: baseUrl || '/',
        onClick: (event) => {
            if (app === 'public') {
                event.preventDefault();
                setLocation(event);
            }
        },
        text: brand,
        theme: 'dark'
    };
};
const createFooterNavTree = (rootStore) => {
    const { setLocation } = rootStore.locationStore;
    const mapFooterColumnsForNavTree = (item) => {
        const url = resolveUrl(item, rootStore.environmentStore);
        return {
            label: item.title,
            url,
            onClick: (event) => {
                var _a;
                if ((_a = event.target) === null || _a === void 0 ? void 0 : _a.href.startsWith('javascript:')) {
                    return;
                }
                pushGaData({ eventAction: 'Footer Item', eventLabel: item.title });
                setLocation(event);
            }
        };
    };
    const items = rootStore.footerColumnStore.columns;
    return items ? items.map((item) => mapFooterColumnsForNavTree(item)) : [];
};
//# sourceMappingURL=FooterColumns.js.map